// İhale Talebi onay akışı statü sabitleri — bkz. docs/LMS-IHALE--FE-Dokumani.txt §4/§7.
// training-request/utils/requestStatus.js ile aynı statü/aksiyon setini kullanır (ortak uç,
// requestType: 3) — bilinçli olarak kopyalanmıştır, bu ekran kendi kendine yeten yeni bir
// ekran (bkz. tender-request/index.jsx üstündeki not).

export const TENDER_STATUS = {
    DRAFT: 10,
    RETURNED: 15,
    PENDING_APPROVAL: 20,
    ACCEPTED: 30,
    REJECTED: 40
};

export const TENDER_STATUS_SEVERITY = {
    [TENDER_STATUS.DRAFT]: 'secondary',
    [TENDER_STATUS.RETURNED]: 'warning',
    [TENDER_STATUS.PENDING_APPROVAL]: 'info',
    [TENDER_STATUS.ACCEPTED]: 'success',
    [TENDER_STATUS.REJECTED]: 'danger'
};

export const TENDER_STATUS_I18N_KEY = {
    [TENDER_STATUS.DRAFT]: 'draft',
    [TENDER_STATUS.RETURNED]: 'returned',
    [TENDER_STATUS.PENDING_APPROVAL]: 'pendingApproval',
    [TENDER_STATUS.ACCEPTED]: 'accepted',
    [TENDER_STATUS.REJECTED]: 'rejected'
};

export const TENDER_STATUS_OPTIONS = [TENDER_STATUS.DRAFT, TENDER_STATUS.RETURNED, TENDER_STATUS.PENDING_APPROVAL, TENDER_STATUS.ACCEPTED, TENDER_STATUS.REJECTED];

export const TENDER_COMMENT_REQUIRED_STATUSES = [TENDER_STATUS.REJECTED, TENDER_STATUS.RETURNED];

// İhale kayıtları için requestType sabiti — LmsCreateRequest/ChangeStatus + GetComments ortak
// uçlarına ve doğrudan LmsTenderRequest uçlarına gönderiliyor.
export const TENDER_REQUEST_TYPE = 3;

export const TENDER_STATUS_ACTIONS = [
    { targetStatus: TENDER_STATUS.PENDING_APPROVAL, icon: 'pi pi-send', colorClass: 'text-blue-500 hover:text-blue-700', i18nKey: 'sendForApproval' },
    { targetStatus: TENDER_STATUS.ACCEPTED, icon: 'pi pi-check', colorClass: 'text-green-500 hover:text-green-700', i18nKey: 'accept' },
    { targetStatus: TENDER_STATUS.REJECTED, icon: 'pi pi-times', colorClass: 'text-red-500 hover:text-red-700', i18nKey: 'reject' },
    { targetStatus: TENDER_STATUS.RETURNED, icon: 'pi pi-replay', colorClass: 'text-orange-500 hover:text-orange-700', i18nKey: 'return' }
];
